import React from 'react';

const Radio = ({ onSelected, selected = false, text = '' }) => (
  <div
    style={{ textAlign: 'left', display: 'flex', cursor: 'pointer' }}
    onClick={onSelected}
  >
    <div
      style={{
        width: '10px',
        height: '10px',
        border: '1px solid #d3d3d3',
        borderRadius: '1000px',
        marginRight: '8px',
        position: 'relative',
        top: '3px',
      }}
    >
      {selected && (
        <div
          style={{
            backgroundColor: '#399ff7',
            width: '8px',
            height: '8px',
            borderRadius: '1000px',
            position: 'relative',
          }}
        ></div>
      )}
    </div>
    <div style={{ flex: 1, display: 'flex' }}>
      <div className="fs-15">{text}</div>
      {text.toLowerCase() === 'other:' && (
        <div style={{ flex: 1 }}>
          <input type="text" />
        </div>
      )}
    </div>
  </div>
);

export default Radio;
